function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 15px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 10;\n\n  .filters__control {\n    visibility: hidden;\n    position: absolute;\n  }\n\n  div.dropdown-input {\n    margin-top: 0;\n  }\n\n  .filters__menu {\n    width: 300px;\n    right: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  right: 0;\n  background-color: #fff;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  padding: 3px 7px;\n  font-size: 0.75rem;\n  border-radius: 5px;\n  transform: translateY(-50%) translateX(50%);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import React, { Component } from "react";
import styled from "styled-components";
import { FaFilter } from "react-icons/fa";
import { withContext, context } from "../../../../wr-context";
import DropdownInput from "../../../../dropdown-input";
import Checkbox from "../../../../checkbox-group/checkbox";
import Button from "../../../../button";
import Badge from "../../../../badge";
var OptionWrapper = styled.div(_templateObject());
var DropdownWrapper = styled.div(_templateObject1());
var StyledBadge = styled(Badge)(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.palette.primary;
}, function(param) {
    var theme = param.theme;
    return theme.palette.primary;
});
var DefaultTriggerButton = function(props) {
    var onClick = props.onClick, countBadge = props.countBadge;
    return /*#__PURE__*/ React.createElement(Button, {
        primary: true,
        onClick: onClick
    }, /*#__PURE__*/ React.createElement(FaFilter, null), countBadge);
};
var FiltersDropdown = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(FiltersDropdown, Component);
    var _super = _createSuper(FiltersDropdown);
    function FiltersDropdown() {
        _classCallCheck(this, FiltersDropdown);
        var _this;
        _this = _super.apply(this, arguments);
        _this.isFocused = false;
        _this.Option = function(props) {
            props.theme.colors.primary = "transparent";
            return /*#__PURE__*/ React.createElement(OptionWrapper, {
                key: props.data.id,
                isSelected: Boolean(props.isSelected),
                onClick: function() {
                    var ref;
                    return (ref = props.selectOption) === null || ref === void 0 ? void 0 : ref.call(props, props.data);
                }
            }, /*#__PURE__*/ React.createElement(Checkbox, {
                type: "checkbox",
                checked: props.isSelected,
                onChange: function() {
                    return null;
                }
            }), " ", /*#__PURE__*/ React.createElement("label", null, props.label));
        };
        _this.selectRef = null;
        _this.triggerSelect = function() {
            if (_this.isFocused && _this.selectRef) {
                var ref;
                (ref = _this.selectRef) === null || ref === void 0 ? void 0 : ref.blur();
            } else {
                var ref1;
                (ref1 = _this.selectRef) === null || ref1 === void 0 ? void 0 : ref1.focus();
            }
        };
        _this.handleFiltersChange = function(filters) {
            if (!filters) {
                filters = [];
            }
            var filtersId = filters.map(function(c) {
                return c.id;
            });
            _this.props.context.actions.updateFilters(filtersId);
        };
        _this.onMenuOpen = function() {
            _this.isFocused = true;
        };
        _this.onMenuClose = function() {
            setTimeout(function() {
                _this.isFocused = false;
            }, 200);
        };
        _this.getFilters = function(filters) {
            var f = filters.slice().sort(function(a, b) {
                if (a.position < b.position) return -1;
                if (a.position > b.position) return 1;
                return 0;
            });
            if (context.utils.products && context.utils.products.getFilters) {
                return context.utils.products.getFilters(f);
            } else {
                return f;
            }
        };
        _this.getValue = function(options) {
            var ref;
            return ((ref = context.state.activeFilters) === null || ref === void 0 ? void 0 : ref.map(function(id) {
                var option = null;
                options.some(function(optGroup) {
                    option = optGroup.options.find(function(opt) {
                        return opt.id === id;
                    });
                    return !!option;
                });
                return option;
            })) || [];
        };
        _this.getSelectRef = function(ref) {
            if (ref) {
                _this.selectRef = ref;
            }
        };
        return _this;
    }
    var _proto = FiltersDropdown.prototype;
    _proto.render = function render() {
        var ref, ref1, ref2, ref3;
        var options = this.getFilters(context.state.filters);
        var filtersSelected = (ref = context.state.activeFilters) === null || ref === void 0 ? void 0 : ref.length;
        var value = this.getValue(options);
        var TriggerButton = ((ref1 = context.theme.components.productList) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.toolbar) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.filtersDropdown) === null || ref3 === void 0 ? void 0 : ref3.buttonComponent) || DefaultTriggerButton;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TriggerButton, {
            "data-testid": "filters-dropdown-trigger",
            onClick: this.triggerSelect,
            selectedFiltersCount: filtersSelected || 0,
            countBadge: Boolean(filtersSelected) ? /*#__PURE__*/ React.createElement(StyledBadge, null, filtersSelected) : /*#__PURE__*/ React.createElement(React.Fragment, null)
        }), /*#__PURE__*/ React.createElement(DropdownWrapper, {
            "data-testid": "product-list-filters-container"
        }, /*#__PURE__*/ React.createElement(DropdownInput, {
            "data-test-id": "filters-dropdown",
            value: value,
            onChange: this.handleFiltersChange,
            getSelectRef: this.getSelectRef,
            onMenuClose: this.onMenuClose,
            onMenuOpen: this.onMenuOpen,
            options: options,
            closeMenuOnSelect: false,
            hideSelectedOptions: false,
            className: "filters",
            classNamePrefix: "filters",
            components: {
                Option: this.Option
            },
            isMulti: true,
            large: true,
            fullWidth: true
        })));
    };
    return FiltersDropdown;
}(Component);
export default withContext(FiltersDropdown);
